import { jwtDecode } from "jwt-decode";
import { decryptData } from "./envryption";

export function isValidJWT(token) {
  if (!token) return false;
  try {
    const decoded = jwtDecode(decryptData(token));

    if (!decoded.exp || typeof decoded.exp !== "number") return false;

    return Date.now() < decoded.exp * 1000; // Check if token is still valid
  } catch (error) {
    return false;
  }
}
